// eslint-disable-next-line import/extensions
import pkg from 'package.json';

export const CONSTANT = {
  // IV: 'cosbrowser-share',
  IV: 'cosbrowser.infox',
  encodeKey: 'cosbrowser.keysx',
};
const cosbrowserDomain = window.location.host;
const mainDomain = cosbrowserDomain.replace(/^cosbrowser./, '');
const officialDomain = mainDomain === 'tencentcloud.com' ? `www.${mainDomain}` : mainDomain;

let defaultLanguage = navigator.language || navigator.userLanguage; // 常规浏览器语言和IE浏览器
defaultLanguage = defaultLanguage.substr(0, 2); // 截取lang前2位字符
export const config = {
  version: pkg.version,
  latestVersion: pkg.version,
  fileMaxSize: 512 * 1024 * 1024 * 1024,
  fileDesktopDropmenuNum: 6,
  searchLimit: 10000, // 搜索的最大条数
  sortLimit: 1000000, // 排序的最大条数
  // fileMaxSize: 1 * 1024 * 1024,
  editTextMaxSize: 1024 * 1024 * 10, // 编辑文件支持的最大文件大小
  docUrl: `https://${officialDomain}/document/product/436/11366`,
  defaultLanguage,
};

const whitelistRegions = [
  {
    region: 'ap-guangzhou-dev',
    region_v4: 'gzdev',
    label_zh: '广州自研',
    label_en: 'guangzhou(Southern China)',
    location_zh: '中国',
  },
  {
    region: 'ap-chongqing-dev',
    region_v4: 'cqdev',
    label_zh: '重庆自研',
    label_en: 'chongqing(Southwestern China)',
    location_zh: '中国',
  },
  {
    region: 'ap-tianjin-dev',
    region_v4: 'tjdev',
    label_zh: '天津自研',
    label_en: 'tianjin(Eorthern China)',
    location_zh: '中国',
  },
  {
    region: 'ap-nanjing-dev',
    region_v4: 'njdev',
    label_zh: '南京自研',
    label_en: 'nanjing(East China)',
    location_zh: '中国',
  },
  {
    region: 'ap-shanghai-dev',
    region_v4: 'shzy',
    label_zh: '上海自研',
    label_en: 'shanghai (East China)',
    location_zh: '中国',
  },
  {
    region: 'pdd-ap-shanghai',
    region_v4: 'pddsh',
    label_zh: '上海拼多多',
    label_en: 'shanghaipdd (East China)',
    location_zh: '中国',
  },
  {
    region: 'ap-qingyuan',
    region_v4: 'qy',
    label_zh: '清远',
    label_en: 'qingyuan (Southern China)',
    location_zh: '中国',
  },
  {
    region: 'ap-qingyuan-xinan',
    region_v4: 'qyxa',
    label_zh: '清远信安',
    label_en: 'qingyuanxinan (Southern China)',
    location_zh: '中国',
  },
  {
    region: 'ap-shanghai-adc',
    region_v4: 'shadc',
    label_zh: '上海自动驾驶云',
    label_en: 'shanghaiad (East China)',
    location_zh: '中国',
  },
  {
    region: 'ap-beijing-cdz-tmap-1',
    region_v4: 'bj-cdz',
    label_zh: '腾讯地图CDZ北京一区',
    label_en: 'Tencent Map CDZ Beijing Zone 1',
    location_zh: '中国',
  },
].map(item => ({
  ...item,
  hidden: true,
  disable_CI: true,
  disable_doc_preview: true,
  disable_deep_CAS: true,
  disable_intelligent_tiering: true,
  disable_media_process: true,
}));

/**
 * disable_maz: 不支持多 AZ
 * disable_CI: 不支持万象合并域名
 * disable_doc_preview: 不支持万象接口:文档预览
 * disable_sts: 不支持请求临时凭证的地域
 * disable_CAS: 不支持归档存储
 * disable_deep_CAS: 不支持深度归档存储
 * disable_intelligent_tiering: 不支持智能分层
 * disable_media_process: 不支持媒体处理地域
 */
export const regions = [
  // 中国
  {
    region: 'ap-nanjing',
    region_v4: 'nj',
    label_zh: '南京',
    label_en: 'Nanjing (Sourtheast China)',
    location_zh: '中国',
    disable_maz: true,
    disable_intelligent_tiering: true,
  },
  {
    region: 'ap-chengdu',
    region_v4: 'cd',
    label_zh: '成都',
    label_en: 'Chengdu (Southwest China)',
    location_zh: '中国',
    location_en: 'China',
    disable_maz: true,
    disable_intelligent_tiering: true,
  },
  {
    region: 'ap-beijing',
    region_v4: 'bj',
    label_zh: '北京',
    label_en: 'Beijing (North China)',
    location_zh: '中国',
    location_en: 'China',
  },
  {
    region: 'ap-guangzhou',
    region_v4: 'gz',
    label_zh: '广州',
    label_en: 'Guangzhou (South China)',
    location_zh: '中国',
    location_en: 'China',
  },
  {
    region: 'ap-shanghai',
    region_v4: 'sh',
    label_zh: '上海',
    label_en: 'Shanghai (East China)',
    location_zh: '中国',
    location_en: 'China',
    disable_maz: true,
  },
  {
    region: 'ap-chongqing',
    region_v4: 'cq',
    label_zh: '重庆',
    label_en: 'Chongqing (Southwest China)',
    location_zh: '中国',
    location_en: 'China',
    disable_maz: true,
    disable_deep_CAS: true,
  },
  {
    region: 'ap-hongkong',
    region_v4: 'hk',
    label_zh: '香港',
    label_en: 'Hongkong',
    location_zh: '中国',
    location_en: 'China',
    disable_maz: true,
    disable_deep_CAS: true,
    disable_intelligent_tiering: true,
    disable_media_process: true,
  },
  {
    region: 'ap-beijing-fsi',
    region_v4: 'bjfsi',
    label_zh: '北京金融',
    label_en: 'Beijing finance',
    location_zh: '中国',
    location_en: 'China',
    disable_maz: true,
    disable_CI: true,
    disable_doc_preview: true,
    disable_sts: true,
    disable_CAS: true,
    disable_deep_CAS: true,
    disable_intelligent_tiering: true,
    disable_media_process: true,
  },
  {
    region: 'ap-shanghai-fsi',
    region_v4: 'shfsi',
    label_zh: '上海金融',
    label_en: 'Shanghai finance',
    location_zh: '中国',
    location_en: 'China',
    disable_maz: true,
    disable_CI: true,
    disable_doc_preview: true,
    disable_CAS: true,
    disable_deep_CAS: true,
    disable_intelligent_tiering: true,
    disable_media_process: true,
  },
  {
    region: 'ap-shanghai-fsi-3',
    region_v4: 'shfsi3',
    label_zh: '上海金融三区',
    label_en: 'Shanghai finance 3',
    location_zh: '中国',
    location_en: 'China',
    disable_maz: true,
    disable_CI: true,
    hidden: true,
    disable_doc_preview: true,
    disable_CAS: true,
    disable_deep_CAS: true,
    disable_upload: true,
    disable_intelligent_tiering: true,
    disable_media_process: true,
  },
  {
    region: 'ap-shenzhen-fsi',
    region_v4: 'szfsi',
    label_zh: '深圳金融',
    label_en: 'Shenzhen finance',
    location_zh: '中国',
    location_en: 'China',
    disable_maz: true,
    disable_CI: true,
    disable_doc_preview: true,
    disable_CAS: true,
    disable_deep_CAS: true,
    disable_intelligent_tiering: true,
    disable_media_process: true,
  },
  // 亚太地区
  {
    region: 'ap-jakarta',
    region_v4: 'jkt',
    label_zh: '印尼雅加达',
    label_en: 'Jakarta',
    location_zh: '亚太地区',
    location_en: 'Asia-Pacific',
    disable_maz: true,
    disable_CI: true,
    disable_doc_preview: true,
    disable_deep_CAS: true,
    disable_intelligent_tiering: true,
    disable_media_process: true,
  },
  {
    region: 'ap-singapore',
    region_v4: 'sgp',
    label_zh: '新加坡',
    label_en: 'Singapore',
    location_zh: '亚太地区',
    location_en: 'Asia-Pacific',
    disable_maz: true,
    disable_CI: true,
    disable_doc_preview: true,
    disable_deep_CAS: true,
    disable_intelligent_tiering: true,
    disable_media_process: true,
  },
  {
    region: 'ap-mumbai',
    region_v4: 'ind',
    label_zh: '印度孟买',
    label_en: 'Mumbai',
    location_zh: '亚太地区',
    location_en: 'Asia-Pacific',
    disable_maz: true,
    disable_CI: true,
    disable_doc_preview: true,
    disable_deep_CAS: true,
    disable_intelligent_tiering: true,
    disable_media_process: true,
  },
  {
    region: 'ap-seoul',
    region_v4: 'kr',
    label_zh: '韩国首尔',
    label_en: 'Seoul',
    location_zh: '亚太地区',
    location_en: 'Asia-Pacific',
    disable_maz: true,
    disable_CI: true,
    disable_doc_preview: true,
    disable_deep_CAS: true,
    disable_intelligent_tiering: true,
    disable_media_process: true,
  },
  {
    region: 'ap-bangkok',
    region_v4: 'th',
    label_zh: '泰国曼谷',
    label_en: 'Bangkok',
    location_zh: '亚太地区',
    location_en: 'Asia-Pacific',
    disable_maz: true,
    disable_CI: true,
    disable_doc_preview: true,
    disable_deep_CAS: true,
    disable_intelligent_tiering: true,
    disable_media_process: true,
  },
  {
    region: 'ap-tokyo',
    region_v4: 'jp',
    label_zh: '日本东京',
    label_en: 'Tokyo',
    location_zh: '亚太地区',
    location_en: 'Asia-Pacific',
    disable_maz: true,
    disable_CI: true,
    disable_doc_preview: true,
    disable_deep_CAS: true,
    disable_intelligent_tiering: true,
    disable_media_process: true,
  },
  // 欧洲地区
  {
    region: 'eu-moscow',
    region_v4: 'ru',
    label_zh: '俄罗斯莫斯科',
    label_en: 'Moscow',
    location_zh: '欧洲地区',
    location_en: 'Europe',
    disable_maz: true,
    disable_CI: true,
    disable_doc_preview: true,
    disable_deep_CAS: true,
    disable_intelligent_tiering: true,
    disable_media_process: true,
  },
  {
    region: 'eu-frankfurt',
    region_v4: 'ger',
    label_zh: '德国法兰克福',
    label_en: 'Frankfurt',
    location_zh: '欧洲地区',
    location_en: 'Europe',
    disable_maz: true,
    disable_CI: true,
    disable_doc_preview: true,
    disable_deep_CAS: true,
    disable_intelligent_tiering: true,
    disable_media_process: true,
  },
  // 北美地区
  {
    region: 'na-toronto',
    region_v4: 'ca',
    label_zh: '加拿大多伦多',
    label_en: 'Toronto',
    location_zh: '北美地区',
    location_en: 'North America',
    disable_maz: true,
    disable_CI: true,
    disable_doc_preview: true,
    disable_deep_CAS: true,
    disable_intelligent_tiering: true,
    disable_media_process: true,
  },
  {
    region: 'na-ashburn',
    region_v4: 'use',
    label_zh: '美东弗吉尼亚',
    label_en: 'Ashburn',
    location_zh: '北美地区',
    location_en: 'North America',
    disable_maz: true,
    disable_CI: true,
    disable_doc_preview: true,
    disable_deep_CAS: true,
    disable_intelligent_tiering: true,
    disable_media_process: true,
  },
  {
    region: 'na-siliconvalley',
    region_v4: 'usw',
    label_zh: '美西硅谷',
    label_en: 'Siliconvalley',
    location_zh: '北美地区',
    location_en: 'North America',
    disable_maz: true,
    disable_doc_preview: true,
    disable_deep_CAS: true,
    disable_intelligent_tiering: true,
    disable_media_process: true,
  },
  // 南美地区
  {
    region: 'sa-saopaulo',
    region_v4: 'sao',
    label_zh: '巴西圣保罗',
    label_en: 'Sao Paulo',
    location_zh: '南美',
    location_en: 'South America',
    disable_maz: true,
    disable_CI: true,
    disable_doc_preview: true,
    disable_deep_CAS: true,
    disable_intelligent_tiering: true,
    disable_media_process: true,
  },
  // 隐藏园区
  {
    region: 'yfb',
    region_v4: 'yfb',
    label_zh: '预发布',
    disable_maz: true,
    disable_CI: true,
    hidden: true,
    disable_doc_preview: true,
    disable_deep_CAS: true,
    disable_upload: true,
    disable_intelligent_tiering: true,
    disable_media_process: true,
  },
  {
    region: 'ap-beijing-1',
    region_v4: 'tj',
    label_zh: '北京一区',
    label_en: 'Tianjin (North China)',
    location_zh: '中国',
    location_en: 'China',
    disable_maz: true,
    hidden: true,
    disable_doc_preview: true,
    disable_deep_CAS: true,
    disable_intelligent_tiering: true,
    disable_media_process: true,
  },
  {
    region: 'ap-guangzhou-2',
    region_v4: 'gzp',
    label_zh: '广州二区',
    label_en: 'ap-guangzhou-2 (South China)',
    location_zh: '中国',
    location_en: 'China',
    disable_maz: true,
    disable_CI: true,
    hidden: true,
    disable_doc_preview: true,
    disable_CAS: true,
    disable_deep_CAS: true,
    disable_intelligent_tiering: true,
    disable_media_process: true,
  },
  {
    region: 'ap-taipei',
    region_v4: 'tpe',
    label_zh: '台湾',
    label_en: 'Taipei',
    location_zh: '中国',
    disable_maz: true,
    disable_CI: true,
    hidden: true,
    disable_doc_preview: true,
    disable_CAS: true,
    disable_deep_CAS: true,
  },
  ...whitelistRegions,
];

/**
 * v4 region map
 */
const _V4RegionMap = {};
regions.forEach(item => {
  _V4RegionMap[item.region] = item.region_v4;
});
export const V4RegionMap = _V4RegionMap;
